export const sentryDsn =
    'https://22bbecc8292e4b8a955a5cc0756017b7@o251606.ingest.us.sentry.io/1437965';
export const sentryOrg = 'make-llc';
export const sentryProject = 'ihme-client-portal';
